import styled from "styled-components";

import {
  FormControl as MuiFormControl,
  InputLabel as MuiInputLabel,
  TextField as MuiTextField,
  Select as MuiSelect,
  SelectProps,
  InputAdornment,
} from "@mui/material";

import {
  DatePicker as MuiDatePicker,
  DatePickerProps,
} from "@mui/x-date-pickers";

import { CalendarToday, Delete } from "@mui/icons-material";

import { Dayjs } from "dayjs";

export const Container = styled.div`
  width: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 25px;
`;

export const Row = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;
  justify-content: start;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #191c1a;
`;

export const Subtitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.17px;
  width: 300px;
  color: #0f0f1e99;
  opacity: 0.6;
`;

export const TextField = styled(MuiTextField)`
  max-width: 300px;

  & .MuiOutlinedInput-root {
    & fieldset {
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: rgb(121, 121, 121);
    }

    &.Mui-focused fieldset {
      border-width: 1px;
    }
  }

  & .MuiInputLabel-root {
    color: rgb(117, 117, 117);
  }
`;

const FormControl = styled(MuiFormControl)`
  width: 300px;
`;

const InputLabel = styled(MuiInputLabel)`
  color: rgb(118, 118, 118);

  & .Mui-focused {
    color: blue;
  }
`;

const Select = styled(MuiSelect)`
  height: 55.3px;
  margin-bottom: 2.7px;

  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const ButtonDelete = styled(Delete)`
  cursor: pointer;
  width: 30px;
`;

interface ISelectFormProps extends Omit<SelectProps, "ref"> {
  label: string;
}

export const SelectForm = ({ label, children, ...selectProps}: ISelectFormProps) => {
  return (
    <FormControl>
      <InputLabel>{label}</InputLabel>
      <Select {...selectProps}>{children}</Select>
    </FormControl>
  );
};

interface IDatePickerFormProps extends Omit<DatePickerProps<Dayjs>, "slotProps"> {}

export const DatePicker = ({ ...datePickerProps }: IDatePickerFormProps) => {
  return (
    <MuiDatePicker
      slotProps={{
        textField: {
          style: { maxWidth: "300px" },
          InputLabelProps: { sx: { color: "rgb(118, 118, 118)" } },
          InputProps: {
            sx: {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgb(189, 189, 189)",
                borderRadius: "8px",
              },
            },
            // endAdornment: (
            //   <InputAdornment position="end">
            //     <CalendarToday
            //       sx={{ color: "rgb(121, 121, 121)" }}
            //       style={{ width: "25px" }}
            //     />
            //   </InputAdornment>
            // ),
          },
        },
      }}
      {...datePickerProps}
    />
  );
};
